import { MESSAGES_MAP } from './constants';

const hasOwnProperty = (value: string) =>
  Object.prototype.hasOwnProperty.call(MESSAGES_MAP, value);

export const getRouteLocale = (locale: string): string => {
  if (hasOwnProperty(locale) && MESSAGES_MAP[locale] === locale) {
    return locale;
  }

  const routeLocale = Object.entries(MESSAGES_MAP).find(
    ([, messageLocale]) => messageLocale === locale,
  )?.[0];

  return routeLocale || locale;
};
